import { render, staticRenderFns } from "./LegaldocflowSignIn.vue?vue&type=template&id=fb39005e&scoped=true&"
import script from "./LegaldocflowSignIn.vue?vue&type=script&lang=js&"
export * from "./LegaldocflowSignIn.vue?vue&type=script&lang=js&"
import style0 from "./LegaldocflowSignIn.vue?vue&type=style&index=0&id=fb39005e&scoped=true&lang=css&"
import style1 from "./LegaldocflowSignIn.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb39005e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/Users/pjabang/projects/taybull-ui/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib'
import { VApp } from 'vuetify/lib'
import { VBtn } from 'vuetify/lib'
import { VCard } from 'vuetify/lib'
import { VCardActions } from 'vuetify/lib'
import { VCardText } from 'vuetify/lib'
import { VContainer } from 'vuetify/lib'
import { VContent } from 'vuetify/lib'
import { VFlex } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
import { VSpacer } from 'vuetify/lib'
import { VTextField } from 'vuetify/lib'
installComponents(component, {VAlert,VApp,VBtn,VCard,VCardActions,VCardText,VContainer,VContent,VFlex,VLayout,VSpacer,VTextField})
